export default __webpack_public_path__ + "static/health-pharma-clinical-trial-8baefff16e4262d05b8eeac698b93971.png";